import { useRouter } from 'next/router';
import { getIsTestRevampGoal } from '@api/selectors/constants';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import useConstants from '@api/hooks/useConstants';
import AllAboutExam from '@cont/NewPreSubscribed/AllAboutExam';
import useContestOnboardingPreference from '@api/hooks/goal/test-series/useContestOnboardingPreference';
import { getCustomPageDetails } from '@utils/getCustomPageDetails';
import { ALL_TEST_SERIES } from '@constants/segment';

import TopBar from './Common/TopBar';
import Breadcrumbs from './Common/Breadcrumbs';
import TestSeriesLanding from './TestSeriesLanding';
import CombatLanding from './Combat/Landing';
import DailyScholarshipTest from './DailyScholarshipTest/DST';
import RevampIntroBanner from './TestRevamp/RevampIntroBanner';

const TestSeriesListing = ({ goalName = '' }) => {
  const { query } = useRouter();
  const { goalUID, goalSlug } = query;
  const { goalInfo } = useGoalInfo(goalUID);
  const pageDetails = getCustomPageDetails(
    goalInfo?.name,
    goalInfo?.title,
    ALL_TEST_SERIES
  );
  const isRevampExp = useConstants(getIsTestRevampGoal({ goalUID }));
  const { contestOnboardingPreferenceData } =
    useContestOnboardingPreference(goalUID);
  const hasCombat = !!contestOnboardingPreferenceData?.[0]?.options;

  const showALLTestSeries = !hasCombat;

  return (
    <>
      <TopBar
        breadcrumbs={
          <Breadcrumbs
            type={
              hasCombat
                ? Breadcrumbs.TYPE.TEST_SERIES_WITH_COMBAT
                : Breadcrumbs.TYPE.ONLY_TEST_SERIES
            }
          />
        }
        title={
          hasCombat ? pageDetails?.testWithTitleCombats : pageDetails?.title
        }
        description={pageDetails?.description}
      />
      {isRevampExp && <RevampIntroBanner />}
      <DailyScholarshipTest
        goalUID={goalUID}
        goalSlug={goalSlug}
        goalName={goalName}
      />
      <TestSeriesLanding
        dataAnalytics="testSeries"
        showAll={showALLTestSeries}
        customPageDetails={pageDetails}
      />
      {hasCombat && <CombatLanding customPageDetails={pageDetails} />}
      <AllAboutExam width="848px" />
    </>
  );
};

export default TestSeriesListing;
